import { render, staticRenderFns } from "./CreateRoutes.vue?vue&type=template&id=de68c9a4"
import script from "./CreateRoutes.vue?vue&type=script&lang=js"
export * from "./CreateRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports